import React from 'react'
import './ourcustomer.css'

function OurCustomer() {
  return (
    <div>
      <div class="ocontainer">
   <div class="oheader">
    <img alt="Logo" height="50" src="https://cdn-icons-png.flaticon.com/128/346/346195.png" width="50"/>
    <h2>
     What Our Customer Says
    </h2>
   </div>
   <div class="testimonials">
    <div class="testimonial">
     <div class="quote">
      <i class="fas fa-quote-left">
      </i>
     </div>
     <div class="stars">
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
     </div>
     <h3>
      Quality Food
     </h3>
     <p>
     I’ve been ordering from Sadapoorna for months now, and the quality is consistently top-notch. The freshness and taste of their produce is far superior to anything I’ve found elsewhere!
     </p>
     {/* <img alt="Tomatoes on a vine" height="100" src="headerlogo2.png" width="100"/> */}
     <hr/>
     <div class="customer">
      <img alt="Customer profile picture" height="40" src="https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg" width="40"/>
      <div>
       <div class="name">
        Michelle Marry
       </div>
       <div class="role">
        Customer
       </div>
      </div>
     </div>
    </div>
    <div class="testimonial">
     <div class="quote">
      <i class="fas fa-quote-left">
      </i>
     </div>
     <div class="stars">
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
      <i class="fas fa-star">
      </i>
     </div>
     <h3>
      Quality Food
     </h3>
     <p>
     Sadapoorna never disappoints! Their products are always fresh, natural, and delivered right to my doorstep. The best part is knowing I'm feeding my family the healthiest food.
     </p>
     {/* <img alt="Hand holding freshly picked carrots" height="100" src="headerlogo2.png" width="100"/> */}
     <hr/>
     <div class="customer">
      <img alt="Customer profile picture" height="40" src="https://static.vecteezy.com/system/resources/previews/005/544/718/non_2x/profile-icon-design-free-vector.jpg" width="40"/>
      <div>
       <div class="name">
        Sarah Albert
       </div>
       <div class="role">
        Customer
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>
    </div>
  )
}

export default OurCustomer
